import React, { useState } from "react";
import Filter from "./components/Filter";
import Farmers from "./components/Farmers";
import FilterResponsive from "./components/FilterResponsive";
import { LoadingOutlined } from "@ant-design/icons";

function MyFarmers() {
  const [loading, setLoading] = useState();
  const [filteredFarmer, setFilteredFarmer] = useState();

  return (
    <>
      <div className="p-6 flex flex-col gap-6">
        <div className="max-sm:hidden">
          <Filter
            setFilteredFarmer={setFilteredFarmer}
            setLoading={setLoading}
          />
        </div>
        <div className="hidden bg-white p-1 rounded-md max-sm:w-full max-sm:block">
          <FilterResponsive
            setFilteredFarmer={setFilteredFarmer}
            setLoading={setLoading}
          />
        </div>
        <div className="bg-white rounded-[15px] px-10 py-8 max-sm:justify-center max-sm:p-2 font-body text-base flex flex-col gap-10">
          {filteredFarmer?.length === 0 && (
            <p>
              {" "}
              کشاورزی برای نمایش وجود ندارد. در این صفحه کشاورزانی که از صفحه
              شخصی شما اقدام به دریافت خدمات می‌کنند نمایش داده می‌شوند.
            </p>
          )}
          {loading ? (
            <div>
              <LoadingOutlined className="text-4xl" />
            </div>
          ) : (
            filteredFarmer?.map((farmer, i) => (
              <Farmers key={i} farmer={farmer} />
            ))
          )}
        </div>
      </div>
    </>
  );
}

export default MyFarmers;
